import { Placement } from '@floating-ui/react';

export enum PositionTypes {
  'Top' = 'top',
  'Bottom' = 'bottom',
  'Right' = 'right',
  'Left' = 'left',
}

export interface TooltipProps {
  content: JSX.Element | string;
  size?: number;
  position?: Placement;
  className?: string;
}
